import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonDataService } from '@app/services/common-data/common-data.service';

@Component({
  selector: 'home-loading-page',
  templateUrl: './home-loading-page.component.html',
  styleUrls: ['./home-loading-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeLoadingPageComponent {
  protected commonDataService = inject(CommonDataService);
}
